import {inject, Injectable} from '@angular/core';
import {RecordData, RecordTableColumnParams, RowMistake} from "../../types/records-table.types";
import {ColumnParamsStateService} from "./column-params-state.service";

@Injectable({
  providedIn: 'root'
})
export class TableBodyService {
  private columnParamsStateService: ColumnParamsStateService = inject(ColumnParamsStateService);

  public isColumnWithBackground(columnParams: RecordTableColumnParams, recordData: RecordData): boolean {
    if (columnParams.enableBackgroundColour) { return true; }
    if (!recordData.rowMistakes?.length) { return false; }
    if (columnParams.key === 'id') { return true; }

    return recordData.rowMistakes.map((mistake: RowMistake) => mistake.fieldName).includes(columnParams.key);
  }

  public getMistakeMessageForCell(columnParams: RecordTableColumnParams, recordData: RecordData): string | null {
    const rowMistakes: Array<RowMistake> = recordData.rowMistakes ?? [];
    if (!rowMistakes.length) { return null; }

    if (columnParams.key === 'id') {
      return this.getSortedMistakesMessage(rowMistakes);
    }

    return rowMistakes.find((rowMistake: RowMistake) => rowMistake.fieldName === columnParams.key)?.message ?? null;
  }

  private getSortedMistakesMessage(rowMistakes: Array<RowMistake>): string {
    const columnOrder = this.columnParamsStateService.columnParamsState().map(param => param.key);
    const sortedRowMistakes = rowMistakes.sort((a, b) =>
      columnOrder.indexOf(a.fieldName) - columnOrder.indexOf(b.fieldName)
    );

    return sortedRowMistakes
      .map((rowMistake: RowMistake, index: number) => `${index + 1}. ${rowMistake.message}`)
      .join('\n');
  }
}
